export default __webpack_public_path__ + "static/media/arrow-right.f773aae9.svg";